import { getFileFullPath } from '../../../utils/Helpers'

const Marketing = () => {
  const arrayOfImages = [
    '1.Portal Dnevno.me-cjenovnik.jpg',
    '2.Portal Dnevno.me-cjenovnik.jpg',
    '3.Portal Dnevno.me-cjenovnik.jpg',
    '4.Portal Dnevno.me-cjenovnik.jpg',
    '5.Portal Dnevno.me-cjenovnik.jpg',
    '6.Portal Dnevno.me-cjenovnik.jpg',
    '7.Portal Dnevno.me-cjenovnik.jpg',
    '8.Portal Dnevno.me-cjenovnik.jpg',
    '9.Mobile Dnevno.me-cjenovnik.jpg',
    '10.Mobile Dnevno.me-cjenovnik.jpg',
    '11.Mobile Dnevno.me-cjenovnik.jpg',
    '12.Mobile Dnevno.me-cjenovnik.jpg',
    '13.Portal Dnevno.me-cjenovnik.jpg',
  ]
  return (
    <>
      <div className="w-full h-full bg-white">
        <div className="text-center pt-20 h-full">
          {arrayOfImages.map((imageUrl, imageIndex) => (
            <a key={imageIndex} href={getFileFullPath(imageUrl, 'Marketing/')}>
              <img
                className="mx-auto"
                src={getFileFullPath(imageUrl, 'Marketing/')}
                alt="Cjenovnik marketinga na Dnevno.me"
              />
            </a>
          ))}
        </div>
      </div>
    </>
  )
}

export default Marketing
